<template>
  <div class="common-modal-wrap">
    <div class="pc-modal-content">
      <div class="pc-modal-header">
        <h2 class="text-lg font-bold">레버리지 변경</h2>
        <button @click="$emit('modal-close')" class="text-gray-500">
          닫기
        </button>
      </div>
      <div class="pc-modal-description-wrap">
        <p class="font-bold text-red-500">
          (격리모드일 경우) 레버리지 상향 후 감소는 해당 포지션 청산 후
          가능합니다.<br />
          신중히 변경해주시기 바랍니다
        </p>
      </div>

      <div class="px-4 py-2">
        <!-- 현재가 -->
        <!-- <p>{{ markPrice }}</p> -->

        <!-- 단계 입력 -->
        <p class="w-full text-left font-bold mb-2">{{ coinName }}</p>
        <p class="w-full text-left mb-1">현재 레버리지</p>
        <div class="input-with-append mb-4">
          <input
            type="number"
            class="input-number"
            placeholder="기존 레버리지"
            v-model="before"
            disabled
          />
          <button type="button" class="btn-no-hover">배</button>
        </div>
        <p class="w-full text-left mb-1">변경 값</p>
        <div class="input-with-append">
          <input
            type="number"
            class="input-number"
            placeholder="변경할 레버리지"
            :min="1"
            :max="125"
            v-model="after"
          />
          <button type="button" class="btn-no-hover">배</button>
        </div>
      </div>

      <div class="p-4">
        <button
          @click="updateLeverage"
          class="bg-blue-500 text-white w-full py-2 rounded"
          v-bind:disabled="isLoading"
        >
          <div v-if="isLoading" class="flex justify-center">
            <VueSpinner size="20"></VueSpinner>
          </div>

          <span v-else>저장</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { storeName } from "@/global/variable";
import { authFetch } from "@/plugins/axiosConfig";
import { VueSpinner } from "vue3-spinners";

export default {
  name: "LeverageModal",
  props: {
    coinName: String,
  },
  components: {
    VueSpinner,
  },
  data() {
    return {
      before: null,
      after: "",
      isLoading: false,
      // 초기화
    };
  },
  created() {
    this.symbolName = this.coinName;
  },
  mounted() {
    this.before = this.$store.getters[`${storeName.asset}/ASSET_CONFIG`](
      this.symbolName
    )?.leverage;
  },

  methods: {
    async updateLeverage() {
      if (!confirm("해당 코인의 레버리지를 변경하시겠습니까?")) return false;
      if (Number(this.after) > 125) {
        alert("최대 125배의 레버리지까지 설정할 수 있습니다.");
        return false;
      }
      if (!Number(this.after)) {
        alert("변경할 레버리지를 입력해주시기 바랍니다");
        return false;
      }
      if (!this.symbolName) {
        alert("올바르지 않은 접근입니다. 잠시 후 다시 시도해주시기 바랍니다.");
        return false;
      }

      const formData = {
        symbol: this.symbolName,
        leverage: this.after,
      };
      const result = await authFetch.patch(
        `/api/member/leverage/${this.symbolName}`,
        formData
      );
      if (result.data.flag) {
        alert("성공적으로 변경되었습니다.");
      } else {
        alert("변경중 오류가 발생했습니다.");
      }

      this.$emit("modal-close");
    },
  },
};
</script>

<style scoped>
/* 스타일 */
</style>
